function parseTimeParts(timeStr) {
  if (!timeStr) {
    return null;
  }
  const [hourPart, minutePart = "0"] = timeStr.split(":");
  const hour24 = Number(hourPart);
  const minute = Number(minutePart);
  const period = hour24 >= 12 ? "pm" : "am";
  const hour12 = hour24 % 12 || 12;
  return { hour12, minute, period };
}

function formatTimePart({ hour12, minute, period }, { includePeriod = true } = {}) {
  const minutes = minute ? `:${String(minute).padStart(2, "0")}` : "";
  const suffix = includePeriod ? period : "";
  return `${hour12}${minutes}${suffix}`;
}

function formatPromoTimeRange(startTime, endTime) {
  const start = parseTimeParts(startTime);
  if (!start) {
    return null;
  }
  const end = parseTimeParts(endTime);
  if (!end) {
    return formatTimePart(start);
  }
  if (start.period === end.period) {
    const startLabel = formatTimePart(start, { includePeriod: false });
    const endLabel = formatTimePart(end);
    return `${startLabel}-${endLabel}`;
  }
  return `${formatTimePart(start)}-${formatTimePart(end)}`;
}

export default function formatPromoSchedule({ date, startTime, endTime }) {
  if (!date) {
    return null;
  }
  const [year, month, day] = date.split("-").map(Number);
  const monthLabel = new Date(year, month - 1, day).toLocaleDateString("en-GB", {
    month: "short"
  });
  const dateLabel = `${day} ${monthLabel}`;
  const timeLabel = formatPromoTimeRange(startTime, endTime);
  if (!timeLabel) {
    return dateLabel;
  }
  return `${dateLabel} - ${timeLabel}`;
}
